import { Point } from './styled-tags-components';
import { TagColor } from '../../../app/entities/tag';
import { SingleSelectDropdown } from '../../../components/select-dropdown';
import { useState } from 'react';

import styles from './color-picker.component.module.scss';
type ColorPickerProps = {
  colorHex: TagColor;
  onChange: (value: TagColor) => void;
};

export const ColorPicker = ({ onChange, colorHex }: ColorPickerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const onOpenChanged = (value?: boolean) => {
    setIsOpen(!!value);
  };

  const options = Object.entries(TagColor).map(([color, colorHex]) => {
    return {
      label: color,
      value: colorHex,
      icon: <Point style={{ marginRight: '0.8rem' }} color={colorHex} />,
    };
  });

  return (
    <SingleSelectDropdown
      onOpenChange={onOpenChanged}
      trigger={() => (
        <button className={styles['next']} data-is-open={isOpen}>
          <Point color={colorHex} />
        </button>
      )}
      title="Color picker"
      options={options}
      value={colorHex}
      onValueChange={(colorHex) => onChange(colorHex as TagColor)}
      placeholder="Pick a color for tag"
    />
  );
};
